// canUndoTip — the ONE client rule for "may this person Undo a tip".
//
// Mirrors the server. undo_tipping(uuid) (live body: mig 20261019150000
// deliveries_corrections_p2, SECURITY DEFINER) refuses with 42501 unless
// has_perm('tipping','edit'), then refuses a COMPLETE / ARCHIVED run (that
// second test is on the run, so callers keep it next to the button). It
// deletes the tipping_log row as definer, so no tipping_log policy widens it.
//
// Enum roles: get_my_permissions resolves the role defaults the way has_perm
// does, and the isManagerOrAbove arm keeps the button when the map has not
// loaded (offline / pending), as it always did.
// Custom role (perms.custom): the map IS has_perm, so ONLY tipping:edit counts.
// A custom role built on a manager fallback, or holding only tipping:manage,
// used to see a button the RPC answered 42501 to (UF-08).
import { isManagerOrAbove } from '@/lib/roles'

export function canUndoTip(
  role: string | undefined | null,
  can: (module: string, action: 'edit') => boolean,
  isCustomRole: boolean,
): boolean {
  if (isCustomRole) return can('tipping', 'edit')
  return isManagerOrAbove(role as never) || can('tipping', 'edit')
}
